/* eslint-disable react/prop-types */
import React from 'react';

// import PropTypes from 'PropTypes';
import { compose } from 'recompose';

import Popover from 'containers/Popover';
import usePopoverBaseHover from 'hooks/usePopoverHover';

import { PopoverBase } from '.';
import { PopoverBaseCTAWrapper } from './popover_styles';

const PopoverBaseCTA = props => {
  const {
    children,
    disabled,
    isPrimary,
    popoverOptions,
    baseProps,
    wrapperClass,
    hideIcon = false,
  } = props;
  const { showIcon, set } = usePopoverBaseHover();

  if (disabled) {
    return children;
  }

  return (
    (<PopoverBaseCTAWrapper
      isPrimary={isPrimary}
      onMouseOver={set(true)}
      onMouseLeave={set(false)}
    >
      {children}
      {showIcon && !hideIcon && (
        <Popover {...popoverOptions}>
          {thisProps => {
            return (
              (<span
                style={{
                  display: 'block',
                }}
                data-palette="PopoverBaseCTA">
                <span className={`base-wrapper ${wrapperClass}`}>
                  <PopoverBase className="base" {...thisProps} {...baseProps} />
                </span>
              </span>)
            );
          }}
        </Popover>
      )}
    </PopoverBaseCTAWrapper>)
  );
};

PopoverBaseCTA.defaultProps = {
  disabled: false,
  isPrimary: true,
  popoverOptions: {},
  baseProps: {},
  wrapperClass: 'buy',
};

// PopoverBaseCTA.propTypes = {
//   children: PropTypes.node.isRequired,
//   disabled: PropTypes.bool,
//   isPrimary: PropTypes.bool,
//   popoverOptions: PropTypes.object,
//   baseProps: PropTypes.object,
//   wrapperClass: PropTypes.string,
// };

const enhance = compose(React.memo);

export default enhance(PopoverBaseCTA);
